import React, { useEffect, useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import { SubTitle } from "../../Components/CustomComponents";
import Table from "../../Components/Table/Table";
import styles from "./styles/training_management.module.scss";

//
import { Col, Row } from "react-bootstrap";
import { useDispatch } from "react-redux"; // for getting and setting data into local redux
import { ShimmerTable } from "react-shimmer-effects";
import CustomBadge from "../../Components/CustomComponents/CustomBadge";
import CustomSpinner from "../../Components/CustomComponents/CustomSpinner";
import TrainingEnrollmentModal from "../../Components/Modals/TrainingEnrollmentModal";
import UserAvatarWithNameAndTag from "../../Components/UserAvatar/UserAvatarWithNameAndTag";
import { useGetAllTrainingEnrollmentQuery } from "../../Data/services/onlyGetsApi";
import { useDeleteCategoryMutation } from "../../Data/services/trainingApi";
import Toast, { SuccessToast } from "../../Hooks/useToast";
// import { useGetAllPostsQuery } from "../../services/postApi";
// import { updatePosts } from "../../features/postSlice";

const TrainingEnrollmentManagementScreen = ({ setPage }) => {
  const dispatch = useDispatch();

  const [viewData, setViewData] = useState("");
  const [deleteModal, setDeleteModal] = useState(false);
  const [UpdateModal, setUpdateModal] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const [indicationMessage, setIndicationMessage] = useState("loading...");
  const [rowData, setRowData] = useState([]);

  const [currentPage, setCurrentPage] = useState(1); // todo
  const [pageSize, setPageSize] = useState(10); // todo
  const [totalRecords, setTotalRecords] = useState(0); // todo
  const [totalPages, setTotalPages] = useState(0); // todo
  const [dataFetched, setDataFetched] = useState(false); // todo
  const { data, isSuccess, isLoading, isFetching, refetch } =
    useGetAllTrainingEnrollmentQuery(
      {
        search: searchQuery.length >= 3 ? searchQuery : "",
        limit: pageSize,
        page: currentPage,
      },
      { refetchOnMountOrArgChange: true }
    );
  // console.log(data);

  const handleSearchChange = (value) => {
    setSearchQuery(value);
  };

  // var allPosts = useSelector((state) => state.posts.data);
  // console.log(`allPosts = ${allPosts}`);

  useEffect(() => {
    if (data) {
      console.log(data);
      setPageSize(data.links.per_page);
      setCurrentPage(data.links.current);
      setTotalRecords(data.links.total_records);
      setTotalPages(data.links.total);
      setRowData(data.data);
      setDataFetched(true);
    }
  }, [data]);

  const handleUpdateModalOpen = () => {
    setUpdateModal(true);
  };

  const handleUpdateModalClose = () => {
    setUpdateModal(false);
    setViewData("");
  };

  const handleDeleteModalOpen = () => {
    setDeleteModal(true);
  };

  const handleDeleteModalClose = () => {
    setDeleteModal(false);
    setViewData("");
  };

  const [deleteCategory, { isLoading: isDeleting }] =
    useDeleteCategoryMutation();

  const deleteData = async (id) => {
    // console.log(editedData.slug);
    // console.log(id);

    const postSlug = id;

    try {
      const { data } = await deleteCategory(postSlug);

      // console.log(data);

      if (data.code === 200) {
        await refetch();
        handleDeleteModalClose();
        SuccessToast(data.message);
      }
    } catch (error) {
      // console.log(error);
      Toast(error.message, "error");
    }
  };

  function indication() {
    return dataFetched && rowData?.length > 0 ? (
      <ShimmerTable row={5} col={1} />
    ) : (
      <p>NO DATA FOUND</p>
    );
  }
  const columns = [
    {
      dataField: "nurse",
      text: "Nurse Name",
      headerStyle: {
        width: "150px",
      },
      formatter: (cellContent, row) => {
        // return <td>{`${row?.firstname} ${row?.lastname}`}</td>;
        return (
          <UserAvatarWithNameAndTag
            userName={`${row?.nurse.firstname} ${row?.nurse.lastname}`}
            avatarImage={row.nurse.image_url || "/images/user-placeholder.jpeg"}
          />
        );
      },
    },
    {
      dataField: "training_batch.name",
      text: "Training Name",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "150px",
      },
    },
    // {
    //   dataField: "training_batch.image_url",
    //   text: "Training Image",
    //   headerStyle: {
    //     width: "150px",
    //   },
    //   formatter: (cellContent, row) => {
    //     // console.log(row?.training_batch.image_url);
    //     return (
    //       <img
    //         alt=""
    //         src={row?.training_batch.image_url}
    //         width={"100%"}
    //         height={100}
    //       />
    //     );
    //   },
    // },

    {
      dataField: "status",
      text: "Status",
      headerStyle: {
        width: "100px",
      },
      formatter: (cellContent, row) => {
        return (
          <CustomBadge
            color={
              row.status === 10 ? "#AAAAAA" : row.status === 20 ?  "#40B559" : "#F35D5D"
            }
            text={
              row.status === 10
                ? "Pending"
                : row.status === 20
                ? "Approved"
                : "Rejected"
            }
          />
        );
      },
    },
    {
      dataField: "actions",
      text: "Actions",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "100px",
      },
      formatter: (cellContent, row) => {
        if (row.id) {
          return (
              <div
                className={`${styles.btnBg} text-white rounded-3 px-3 py-2 d-flex align-items-center justify-content-center`}
                role="button"
                onClick={() => {
                  setViewData(row);
                  handleUpdateModalOpen(true);
                }}
              >
                <span className={`d-flex align-items-center pe-1`}>
                  {/* <MdDeleteForever /> */}
                </span>
                <span>Show</span>
              </div>
          );
        }
      },
    },
  ];

  return (
    <div className={styles.MainContainer}>
      {/* {deleteModal ? (
        <DeleteModal
          handleDeleteModalClose={handleDeleteModalClose}
          data={viewData}
          onDelete={deleteData}
          isDeleting={isDeleting}
        />
      ) : (
        ""
      )} */}
      {UpdateModal ? (
        <TrainingEnrollmentModal
          handleUpdateModalClose={handleUpdateModalClose}
          data={viewData}
          refetch={refetch}
        />
      ) : (
        ""
      )}

      <div className={styles.headerContainer}>
        <Row className="w-100 flex-start justify-content-between">
          <Col md={6}>
            <div>
              <SubTitle text={"Training Enrollment"} classes="primary-text" />
            </div>
          </Col>
          {/* <Col md={5}>
            <Input
              placeholder="search by name"
              value={searchQuery}
              onChange={(e) => handleSearchChange(e.target.value)}
            />
          </Col> */}
          {/* <Col md={2}>
            <Button
              classes={`h-100 mt-3 mt-md-0`}
              text="Add Category"
              onClick={handleUpdateModalOpen}
            ></Button>
          </Col> */}
        </Row>
      </div>

      <div className={styles.mainTable}>
        {!dataFetched ? (
          <CustomSpinner />
        ) : (
          <Table
            classes={`${dataFetched && isFetching ? "blur-table" : ""}`}
            data={rowData ?? []}
            columns={columns}
            indication={indication}
            totalRecords={totalRecords} // todo
            totalPages={totalPages} // todo
            pageSize={pageSize} // todo
            currentPage={currentPage} // todo
            setCurrentPage={setCurrentPage} // todo
            setPageSize={setPageSize} // todo
            refetch={refetch} // todo
          />
        )}
      </div>
    </div>
  );
};

export default TrainingEnrollmentManagementScreen;
